import { render } from "./AccordionSelect.vue?vue&type=template&id=648bd856"
import script from "./AccordionSelect.vue?vue&type=script&lang=js"
export * from "./AccordionSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/components/AccordionSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "648bd856"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('648bd856', __exports__)) {
    api.reload('648bd856', __exports__)
  }
  
  module.hot.accept("./AccordionSelect.vue?vue&type=template&id=648bd856", () => {
    api.rerender('648bd856', render)
  })

}


export default __exports__